import { Interp, css } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function ReqCompose({ v }) {
  if (!v.showReqCompose) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.clearReqTo}>
        <div className="gp-venster" onClick={v.stopProp} style={{ "width": "min(440px,100%)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "13px", "boxSizing": "border-box" }}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px" }}>
            <span style={{ "fontSize": "20px", "flex": "0 0 auto" }}>
              ✉️
            </span>
            <div style={{ "fontSize": "19px", "fontWeight": "700", "flex": "1 1 auto" }}>
              Stuur een verzoekje
            </div>
            <button onClick={v.clearReqTo} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={20} />
            </button>
          </div>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "8px" }}>
            <span style={css(v.reqPickChipStyle)}>
              {' '}
              <img alt="" src={v.reqPickAvatarUrl} style={{ "width": "20px", "height": "20px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
              {' '}
              <span style={{ "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                <Interp v={v.reqPickName} />
              </span>
              {' '}
            </span>
            <span style={{ "fontSize": "12px", "fontWeight": "600", "color": "var(--tekst-3)" }}>
              krijgt jouw verzoekje
            </span>
          </div>
          <textarea value={v.reqText ?? ''} onInput={v.onReqInput} placeholder="Bijv. wie tekent er een kat voor me?" rows="3" style={{ "fontFamily": "inherit", "fontSize": "14px", "padding": "10px 12px", "border": "3px solid var(--ink)", "borderRadius": "12px", "outline": "none", "width": "100%", "boxSizing": "border-box", "resize": "vertical" }} />
          {v.hasReqError ? (<>
            <div style={{ "fontSize": "13px", "color": "var(--fout)", "fontWeight": "600" }}>
              <Interp v={v.reqError} />
            </div>
          </>) : null}
          <button onClick={v.submitRequest} className="gp-btn pink" disabled={v.reqSending} style={css(v.hoofdKnopStyle)}>
            <Interp v={v.reqBtnLabel} />
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
